const styles = (theme) => ({
  card: {
    background: theme.color.grey_ee,
  },
  title: {
    fontSize: 16,
    color: theme.color.grey_77,
    marginBottom: theme.spacing(1.25),
  },
  label: {
    fontSize: 14,
    display: 'inline-block',
    minWidth: 70,
    textTransform: 'uppercase',
    color: theme.color.grey_77,
  },
  checkbox: {
    marginTop: theme.spacing(1.25),

    '& .MuiIconButton-root': {
      marginRight: 0,
    },
  },
  toggleHeader: {
    maxWidth: 500,
    margin: 'auto',
  },
  btn: {
    marginBottom: theme.spacing(2),
  },
  resetBtn: {
    marginTop: '10px',
    display: 'block',
    color: '#696969',
  },
});

export default styles;
